import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=f7b7d0e4&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=f7b7d0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b7d0e4",
  null
  
)

export default component.exports